import { NavLink } from "react-router-dom";
import "./GenerateButton.css";

export default function GenerateButton({ 
  hasSetlist = false, 
  className = "", 
  onClick = null,
  variant = "nav" // "nav" or "landing"
}) {
  const content = (
    <>
      {hasSetlist && <span className="generate-btn-icon">♻️</span>}
      <span className="generate-btn-text">
        {hasSetlist ? "Re-Generate" : "Generate"}
        {variant === "landing" && " Show"}
      </span>
    </>
  );

  const variantClass = variant === "landing" ? "generate-btn-landing" : "";

  // If onClick provided, render as button (for Landing page)
  if (onClick) {
    return (
      <button
        className={`generate-btn ${variantClass} ${hasSetlist ? "generate-btn-secondary" : "generate-btn-primary"} ${className}`}
        onClick={onClick}
      >
        {content}
      </button>
    );
  }

  // Otherwise render as NavLink (for Navigation)
  return (
    <NavLink
      to="/generate"
      className={`generate-btn ${variantClass} ${hasSetlist ? "generate-btn-secondary" : "generate-btn-primary"} ${className}`}
    >
      {content}
    </NavLink>
  );
}
